import { render, staticRenderFns } from "./BannerFooter.vue?vue&type=template&id=156c48c3&"
import script from "./BannerFooter.vue?vue&type=script&lang=ts&"
export * from "./BannerFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports